var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.694 10.227c0-.709-.064-1.39-.183-2.045h-9.463v3.868h5.408a4.599 4.599 0 01-2.005 3.018v2.51h3.247c1.9-1.742 2.996-4.305 2.996-7.35z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.048 20c2.713 0 4.987-.895 6.65-2.422l-3.248-2.51c-.9.6-2.05.955-3.402.955-2.617 0-4.833-1.759-5.623-4.123H1.068v2.591a10.05 10.05 0 008.98 5.51z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.426 12.224a5.985 5.985 0 01-.315-1.9c0-.659.114-1.3.315-1.9v-2.59H1.069A9.957 9.957 0 000 10.323c0 1.614.388 3.141 1.069 4.491l3.357-2.59z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.048 3.977c1.475 0 2.8.505 3.84 1.496l2.883-2.868C15.03.99 12.756 0 10.048 0a10.05 10.05 0 00-8.98 5.51L4.425 8.1c.79-2.364 3.006-4.123 5.623-4.123z",
    fill: "#EA4335"
  })));
}
export default SvgGoogleLogo;